<template>
    <div class="detail-wrap">
      <!-- 微信认证组件 -->
      <wxAuth :share="share" ref="child"></wxAuth>
      <!-- title -->
      <headers :params="hraderP"></headers>
      <div class="detail-wrap-content">
        <div class="detail-header">
          <div class="detail-header-title">{{newsDetail.columnTitle}}</div>
          <div class="detail-header-tag">
            <div>
                <span class="tag" v-if="newsDetail.tagName" @click="toNewsList(newsDetail.tagName)">{{newsDetail.tagName}}</span>
            </div>
            <div class="time">{{newsDetail.createTime}}</div>
          </div>
          <div class="detail-header-desc" v-if="newsDetail.columnIntroduction">{{newsDetail.columnIntroduction}}</div>
        </div>

        <div class="detail-content" @click="imageView($event)" v-html="newsDetail.columnText"></div>
        <div id="frameVideo-box"></div>
        <div class="detail-explain" v-if="newsDetail.pageView"><span>{{newsDetail.pageView | myriabit}}</span>阅读量</div>
      </div>
      <template v-if="newsDetail.userId">
        <div class="public-header" >
          <div class="public-header-left">内容来源</div>
        </div>
        <div class="to-user-index">
          <div class="to-user-index-left">{{newsDetail.firmName}}</div>
          <div class="public-header-right"><router-link :to="`/user/index/${newsDetail.userId}.html`"><span>进入主页</span></router-link> <van-icon name="arrow" /></div>
        </div>
      </template>
      <div class="public-header" v-if="params.list.length>0">
        <div class="public-header-left">推荐阅读</div>
      </div>
      <list :params="params"></list>
    </div>
</template>

<script>
import headers from '@/components/headers'
import { getColumnDetail, getColumnRelevance } from '@/api/news/news'
import list from '@/components/list'
import logo from '@/assets/logo.png'
import wxAuth from '@/components/wxAuth'
import { ImagePreview } from 'vant'
import { myriabit } from '@/filters/commonFilters'
import { isMobile } from '@/utils/common'
export default {
  name: 'news-detail',
  filters: { myriabit },
  data () {
    return {
      share: {
        title: this.newsDetail ? this.newsDetail.columnTitle : '解决方案馆',
        desc: this.newsDetail ? this.newsDetail.columnIntroduction : '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: this.newsDetail ? this.newsDetail.matchPic : 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      columnId: '',
      newsDetail: {},
      params: {
        list: [],
        type: 'info',
        label: 'true',
        total: null
      },
      logo,
      hraderP: {
        title: '资讯详情',
        lefticon: true
      }
    }
  },
  components: {
    list,
    wxAuth,
    headers
  },
  mounted () {
    this.getUrlParams()
    this.getNewsDetail()
  },
  watch: {
    $route (from, to) {
      this.getUrlParams()
      this.getNewsDetail()
    }
  },
  methods: {
    imageView (e) {
      // 判断当前点击的是图片
      if (e.target.tagName === 'IMG') {
        ImagePreview([
          e.target.src
        ])
      }
    },
    toNewsList (tagName) {
      this.$router.push({ path: '/news/list.html', query: { tagName } })
    },
    // 获取路由参数
    getUrlParams () {
      this.columnId = this.$route.params.id
    },
    // 根据路由参数获取资讯详情
    getNewsDetail () {
      getColumnDetail(this.columnId).then(res => {
        if (res.data.code === 200) {
          this.newsDetail = Object.assign({}, res.data.data, {
            firmName: res.data.data.brandFirmResp ? res.data.data.brandFirmResp.firmName : '',
            userId: res.data.data.brandFirmResp ? res.data.data.brandFirmResp.userId : ''
          })
          if (this.newsDetail.columnType === 3) {
            this.hraderP.title = '观点大咖说'
          }
          // if (this.newsDetail.columnType === 2) {
          //   this.initVideoDetail()
          // }
          if (!isMobile()) {
            let pcUrl = this.newsDetail.columnType === 2 ? `${process.env.PC_SOLUTION_URL || '//solution.homedo.com/'}/info/view/detail/${this.columnId}.html` : `${process.env.PC_SOLUTION_URL || '//solution.homedo.com/'}/info/news/detail/${this.columnId}.html`
            window.location.href = pcUrl
          }
          this.share.title = this.newsDetail.columnTitle
          this.share.desc = this.newsDetail.columnIntroduction
          this.share.imgUrl = this.newsDetail.matchPic || 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg'
          this.$refs.child.wxAuth()
        }
      })
      const data = {
        limit: 5
      }
      getColumnRelevance(data, this.columnId).then(res => {
        if (res.data.code === 200) {
          this.params.list = [...res.data.data.list]
        }
      })
    },
    initVideoDetail () {
      var url = this.newsDetail.columnVideo
      if (!url) {
        url = this.newsDetail.resourceList[0] ? this.newsDetail.resourceList[0].resourceUrl : this.newsDetail.videoPic
      }
      let urlType = url.substring(url.lastIndexOf('.') + 1)
      let viewBox = ''
      if (urlType === 'mp4') {
        viewBox = document.createElement('video')
        viewBox.src = url
        viewBox.setAttribute('autoplay', 'autoplay')
      } else {
        viewBox = document.createElement('embed')
        viewBox.src = url
        viewBox.setAttribute('allowFullScreen', 'true') 
        viewBox.setAttribute('isAutoPlay', 'true')
      }
      viewBox.setAttribute('id', 'frameVideo')
      viewBox.setAttribute('class', 'frameVideo')
      document.querySelector('#frameVideo-box').append(viewBox)
    }
  }
}
</script>

<style lang="scss">
  .detail-wrap {
    overflow-x: hidden;
    &-content {
      background-color: #fff;
      padding: 15px 0;
    }
    .detail-header {
      padding: 0 15px;
      &-title {
        margin-bottom: 10px;
        font-size: 16px;
        color: #222;
      }
      &-tag {
        display: flex;
        justify-content: space-between;
        font-size: 10px;
        .tag {
          color: #1cc0da;
          margin-right: 20px;
        }
        .time {
          color: #a0a0a0;
        }
      }
      &-desc {
        margin: 15px 0;
        padding: 10px;
        background: #f5f9fa;
        font-size: 13px;
        color: #666;
      }
    }
    .detail-content {
      margin: 0 15px;
      background-color: #fff;
      overflow: hidden;
      img {
        max-width: 100% !important;
        height: auto !important;
      }
      div, span, p, strong {
        font-size: 14px!important;
        line-height: 1.5 !important;
        word-break: break-all;
      }
      h1,h2,h3,h4,h5,h6 {
        font-size: 16px!important;
        line-height: 1.5;
        word-break: break-all;
      }
    }
    .detail-explain {
      padding: 0 15px;
      background-color: #fff;
      margin-top: 10px;
      font-size: 10px;
      color: #a0a0a0;
      span {
        color: #f8a325;
        margin-right: 5px;
      }
    }
    #frameVideo-box {
      width: 100%;
      &> embed {
        width: 100%;
        height: 8rem;
      }
    }
  }
  .to-user-index {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 39px;
    padding: 0 15px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/newsDetail.vue